import AgentDocumentationRoutes, {ROOT_URI} from 'Agent/AgentDocumentation/AgentDocumentationRouteConstants';
import AllAppAndEnrollMyWay from 'Agent/AgentDocumentation/components/AllAppAndEnrollMyWay';
import DirectDepositInformation from 'Agent/AgentDocumentation/components/DirectDepositInformation';
import React from 'react';
import {Route, Switch} from 'react-router';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import ProducerCompliancePolicy from 'Agent/AgentDocumentation/components/ProducerCompliancePolicy';

type AgentDocumentationProps = {
  selectedAgency: AgencyFilters;
};

export default ({selectedAgency}: AgentDocumentationProps) => (
  <Route
    path={ROOT_URI}
    render={() => (
      <Switch>
        <Route
          path={`${AgentDocumentationRoutes.DIRECT_DEPOSIT_INFORMATION}`}
          render={routeProps => <DirectDepositInformation {...routeProps} selectedAgency={selectedAgency} />}
          exact
        />
        <Route
          exact
          path={AgentDocumentationRoutes.ALL_APP_AND_ENROLL_MY_WAY}
          render={() => <AllAppAndEnrollMyWay />}
        />
        <Route
          exact
          path={AgentDocumentationRoutes.PRODUCER_COMPLIANCE_POLICY}
          render={() => <ProducerCompliancePolicy selectedAgency={selectedAgency} />}
        />
      </Switch>
    )}
  />
);
